"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const SearchModalHCountourDiv = styled_components_1.default.div `
  height: 1px;
  border-radius: 0.5px;
  background-color: #f1f1f1;
`;
const SearchModalHCountour = () => {
    return (0, jsx_runtime_1.jsx)(SearchModalHCountourDiv, { className: "Search__Modal__HCountour" });
};
exports.default = SearchModalHCountour;
